import FooterBottomComponent from './FooterBottomComponent'

export default FooterBottomComponent
